// eslint-disable-next-line import/named
import { createRoute, redirect } from "@tanstack/react-router";

import AskPunttStyleGuide from "./style-guide";

import PendingComponent from "../../components/PendingComponent";
import { isMeaningfulGigsRole } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const askPunttStyleGuideRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "ask-puntt/style-guide",
  beforeLoad() {
    if (!isMeaningfulGigsRole()) {
      throw redirect({ to: ticketsRoute.to });
    }
  },
  component: AskPunttStyleGuide,
  pendingComponent: PendingComponent,
  gcTime: 0,
  shouldReload: false,
  pendingMs: 0,
  pendingMinMs: 500,
});
